import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Testimonials" className="bg-ice text-obsidian" data-id="element-278" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" style={{
      paddingTop: "19px",
      paddingBottom: "24px"
    }} data-id="element-279" data-mp="3fycp7jantz97">
        <h2 className="text-center font-display text-[26px] font-extrabold tracking-tight text-obsidian sm:text-4xl" data-id="element-280" data-mp="3b0axk9z64rm4">
          🗣️ Fire Service Testimonials
        </h2>
        <div className="mt-10 grid w-full grid-cols-1 gap-5 md:grid-cols-3" data-id="element-281" data-mp="31yuvcpiibvsz">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.06} data-id="element-282" data-mp="2x1l0uvg9gtya" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}